const AutoCompleteStylingScrapReturn= {
  container: (provided) => ({
      
      width: "100%",
      ...provided,
  }),

}
export default AutoCompleteStylingScrapReturn